import { z } from 'zod'

export const Date = z.string().date()
export type Date = z.infer<typeof Date>
